import { Injectable } from '@angular/core';
import Quagga from '@ericblade/quagga2';
import { ProcessedImage } from './processed-image.interface';

@Injectable({
  providedIn: 'root',
})
export class QuaggaService {
  async processImage(takenImagePng: string): Promise<ProcessedImage> {
    const startTime = Date.now();
    let finalResult = '';

    // TODO: time
    try {
      let result = await Quagga.decodeSingle({
        src: takenImagePng,
        numOfWorkers: 0,
        decoder: {
          readers: ['code_128_reader', 'code_39_vin_reader'],
        },
      });
      if (result && result.codeResult) {
        console.log('Barcode Format:', result.codeResult.format);
        console.log('Barcode Value:', result.codeResult.code);
        finalResult = result.codeResult.code ?? '';
      } else {
        console.error('No barcode detected.');
        finalResult = 'No Barcode';
      }
    } catch (error) {
      console.error('Error in Quagga', error);
      finalResult = 'Error: ' + error.message;
    } finally {
      const timeSeconds = Math.round(Date.now() - startTime) / 1000;

      return {
        result: finalResult,
        time: timeSeconds,
      };
    }
  }
}
